export default {
    baseStyle: () => ({
        '.slick-arrow': {
            zIndex: '2',
            display: 'none !important',
            height: '30px !important'
        },
        '.slick-prev': {
            left: '2px'
        },
        '.slick-next': {
            right: '4px !important'
        },
        '.slick-prev:before': {
            content: '"\f104"'
        },
        '.slick-next:before': {
            content: "'\f105'"
        },
        '.slick-dots': {
            bottom: '10px !important'
        },
        '.slick-dots li button:before': {
            fontSize: '10px !important'
        }
    })
}
